import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import type { Layout } from '@mentimeter/http-clients';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { TitleSection } from '@mentimeter/question-modules-shared';
import { useQuizResults } from '@mentimeter/quiz';
import { Box } from '@mentimeter/ragnar-ui/box';
import { CenteringContainer } from '../../shared/components/quiz/CenteringContainer';
import { RevealAnswer } from '../../shared/components/quiz/RevealAnswer';
import { Results } from './results/Results';

export const PublicPresentation = ({
  question,
  questionStyled,
  correctAnswer,
  meta,
  description,
  layout,
}: {
  question: string;
  questionStyled: Record<string, unknown>;
  correctAnswer: string | undefined;
  meta: string;
  description: string;
  layout: Layout | undefined;
}) => {
  const { useConfig, InteractiveCanvasComponents, useTranslate } =
    usePresentationContext();
  const { enableAnimations, readonly } = useConfig();
  const translationFn = useTranslate();
  const { data = [], isPreviewResults } =
    useQuizResults<QuizPlayersScoreData>();

  const shouldShowResults = !isPreviewResults || data.length > 0;

  const ConditionalWrapper =
    InteractiveCanvasComponents?.CanvasVisualizationArea
      ? InteractiveCanvasComponents?.CanvasVisualizationArea
      : Box;

  return (
    <>
      <TitleSection
        question={question}
        questionStyled={questionStyled}
        question_description={description}
        title_meta={meta}
        fontSizeOffset={layout?.font_size_offset}
        showTextSizeDropdown={true}
      />
      <ConditionalWrapper width="100%" flex="1">
        <CenteringContainer>
          {shouldShowResults && (
            <RevealAnswer
              correctAnswer={correctAnswer}
              enableAnimation={enableAnimations}
            >
              <Results
                results={data}
                isReadonly={readonly}
                translationFn={translationFn}
              />
            </RevealAnswer>
          )}
        </CenteringContainer>
      </ConditionalWrapper>
    </>
  );
};
